import gql from 'graphql-tag';
import { DocumentAttachmentFragments } from './document-attachment.fragments';

export class DocumentAttachmentMutations {
  static update = gql`
    mutation UpdateDocumentAttachment(
      $id: String!
      $requireView: Boolean
      $accessRecipientList: [String!]
    ) {
      updateDocumentAttachment(
        id: $id
        requireView: $requireView
        accessRecipientList: $accessRecipientList
      ) {
        id
      }
    }
  `;

  static delete = gql`
    mutation RemoveDocumentAttachment($id: String!) {
      removeDocumentAttachment(id: $id)
    }
  `;

  static create = gql`
    mutation AddAttachmentToDocument(
      $documentId: String!
      $attachmentId: String!
      $restrictAccess: Int
      $requireView: Int
      $accessRecipientList: [String!] = []
      $fromLibrary: Boolean
    ) {
      addDocumentAttachment(
        documentId: $documentId
        attachmentId: $attachmentId
        restrictAccess: $restrictAccess
        requireView: $requireView
        accessRecipientList: $accessRecipientList
        fromLibrary: $fromLibrary
      ) {
        ...documentAttachmentFragment
      }
    }
    ${DocumentAttachmentFragments.documentAttachment}
  `;
}
